/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'typefolder': {
    width: 200,
    height: 160,
    viewBox: '0 0 200 160',
    data: '<g fill-rule="evenodd"><path pid="0" d="M80.526 9.953c-9.95 0-14.93 6.14-14.93 18.42v98.27c0 12.28 4.98 18.42 14.93 18.42h94.59c9.95 0 14.93-6.14 14.93-18.42v-98.27c0-12.28-4.98-18.42-14.93-18.42h-94.59z" _fill="#ebbb5d"/><path pid="1" d="M0 142.22V17.78C0 7.96 8.39 0 18.75 0h54.61c8.37 0 15.73 5.26 18.03 12.9l5.04 16.73h84.82c10.36 0 18.75 7.96 18.75 17.78v94.81c0 9.82-8.39 17.78-18.75 17.78H18.75C8.39 160 0 152.04 0 142.22z" _fill="#ffd977"/></g>'
  }
})
